var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedcorisArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 30,
    viewBox: "0 0 41 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.73645,
    height: 20.8081,
    transform: "matrix(0.724558 0.689214 -0.724558 0.689214 37.5461 12.8698)",
    fill: "#FF5D5D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.73645,
    height: 20.5505,
    transform: "matrix(0.724558 -0.689214 0.724558 0.689214 21.3281 2.5752)",
    fill: "#FF5D5D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.01061,
    height: 16.766,
    transform: "matrix(0.724558 0.689214 -0.724558 0.689214 28.8367 13.3698)",
    fill: "#FF5D5D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3.01061,
    height: 16.5584,
    transform: "matrix(0.724558 -0.689214 0.724558 0.689214 15.7692 5.07495)",
    fill: "#FF5D5D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.63429,
    height: 14.6702,
    transform: "matrix(0.724558 0.689214 -0.724558 0.689214 20.8956 13.5735)",
    fill: "#FF5D5D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.63429,
    height: 14.4886,
    transform: "matrix(0.724558 -0.689214 0.724558 0.689214 9.46154 6.31555)",
    fill: "#FF5D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedcorisArrow);
export default __webpack_public_path__ + "static/media/redcoris-arrow.ff255b8bfe4e19b8f03e6b550935dfad.svg";
export { ForwardRef as ReactComponent };